export default class SkillsHeadline extends React.Component {
  render () {
    let entity = gon.entity || 'Candidate';
    let not_portal = gon.application.portal === false
    if (entity) {
      return (
        <div className="headline">
          <div className="skill-name">{I18n.t('skills.skills')}</div>
          {not_portal && <div className="skill-candidate">{I18n.t('skills.candidate')}</div>}
          {not_portal &&
            <div className="skill-hr text-center">{I18n.t('skills.hr')}</div>}
          {not_portal && entity !== 'Employee' &&
            <div className="main-skill text-center pright10">
              <i rel="tooltip" data-placement="left" className="ti ti-help-alt" title={I18n.t(`skills.main_skills_help.${entity.toLowerCase()}`)} />
            </div>}
        </div>
      )
    } else {
      console.warn('SkillsHeadline cannot be displayed - gon.ENTITY is undefined')
      return null
    }
  }
}
